import { v4 as uuidv4 } from 'uuid';

const recurringTransactions = (account) => {
  const postedOn = '2025-04-15';

  const baseTransaction = {
    source: 'QCS_REFRESH',
    accountId: account?.id,
    postedOn,
    payee: 'United States Treasury',
    coa: {
      type: 'UNCATEGORIZED',
      id: '0',
    },
    amount: -100,
    state: 'CLEARED',
    matchState: 'NOT_MATCHED',
    cpData: {
      id: uuidv4(),
      cpPendingId: uuidv4(),
      postedOn,
      txnOn: postedOn,
      amount: -100,
      payee: 'United States Treasury',
      inferredPayee: 'United States Treasury',
      inferredCoa: {
        type: 'UNCATEGORIZED',
        id: '0',
      },
      cpCategoryId: '2002',
    },
    type: 'CASH_FLOW',
  };
  return [
    {
      ...baseTransaction,
      postedOn: '2025-01-15',
      amount: -50,
      cpData: {
        ...baseTransaction.cpData,
        id: uuidv4(),
        cpPendingId: uuidv4(),
        postedOn: '2025-01-15',
        amount: -50,
      },
    },
    {
      ...baseTransaction,
      postedOn: '2025-04-15',
      amount: -50,
      cpData: {
        ...baseTransaction.cpData,
        id: uuidv4(),
        cpPendingId: uuidv4(),
        postedOn: '2025-04-15',
        amount: -50,
      },
    },
  ];
};

export default recurringTransactions;
